/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Id of wallet application
 */

export type WalletApplicationId = t.TypeOf<typeof WalletApplicationId>;
export const WalletApplicationId = t.string;
